import React from "react";

function PageNotFound() {
  return <h1>404 :(</h1>;
}

export default PageNotFound;
